export default __webpack_public_path__ + "static/media/person1@2x.660590a3.jpg";